import React from 'react'

import globalStyles from "../../../../App.module.scss";

import size_f from './images/size_f.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function DiskUsageByFolder() {
    let data = `#!/bin/bash
directories=$(ls)

for i in $directories; do
  if [ -d "$i" ]; then files="$files $i"; fi
done

echo ------------------------------------------------------

for i in $files; do size=$(du $i -sh | awk '{print $1}') && printf "%-30s | %-30s\\n" $i $size; done

echo ------------------------------------------------------

for i in $files; do size=$(du $i -s | awk '{print $1}') && total=$(($total + $size)); done

result_mb=$(echo "scale=2;$total / 1024" | bc)
result_round=$((total / 1024))

if [ $result_round -lt 1000 ]; then
  printf "%-30s | %-30s\\n" "Total" $result_mb"Mb"
else
  result_gb=$(echo "scale=2;$result_mb / 1024" | bc)
  printf "%-30s | %-30s\\n" "Total" $result_gb"Gb"
fi`

    return (
        <div className={globalStyles.article}>
            <h1>Folder disk usage</h1>
            <p>This script provides an overview of the current directory contents and the disc space each folder
                takes.</p>
            <SyntaxHighlighter
                children={data}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <p>The script above produces the next output:</p>
            <div><img src={size_f} alt={""}/></div>
        </div>
    )
}